// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export class FundingRateMarkupPlan {
    public _dataByInstruments: any = {};
    public _dataByInstrumentGroup: any = {};
    public _defaultData: any;
    public _dataByInstrumentsHasValue = false;
    public _dataByInstrumentGroupHasValue = false;
    public Name;
    public Id: any;

    constructor (id) {
        this.Id = id;
    }

    public GetData (instr): any {
        if (instr === null) {
            return null;
        }

        let data = this._dataByInstruments[instr.Id];// InstrumentId === Id
        if (data) {
            return data;
        }

        data = this._dataByInstrumentGroup[instr.TypeId]; // InstrumentGroupId === TypeId
        if (data) {
            return data;
        }

        return this._defaultData;
    }

    public Update (message): void {
        this.Name = message.Name;
        this._dataByInstruments = {};
        this._dataByInstrumentGroup = {};
        this._defaultData = null;
        this._dataByInstrumentsHasValue = false;
        this._dataByInstrumentGroupHasValue = false;

        for (let i = 0; i < message.Data.length; i++) {
            this.AddData(message.Data[i]);
        }
    }

    public AddData (data): void {
        if (data.InstrumentId) {
            this._dataByInstruments[data.InstrumentId] = data;
            this._dataByInstrumentsHasValue = true;
        } else if (data.InstrumentGroupId !== null) {
            this._dataByInstrumentGroup[data.InstrumentGroupId] = data;
            this._dataByInstrumentGroupHasValue = true;
        } else {
            this._defaultData = data;
        }
    }
}
